import { camelCase, keys, isEmpty, isFinite } from 'lodash'

export const getQueries = (search = ''): Record<string, string> => {
  if (isEmpty(search)) {
    return {}
  }
  search = search.replace('?', '')
  const queries = search.split('&')

  return queries.reduce((result: Record<string, string>, query: string) => {
    const [key, value] = query.split('=')
    result[camelCase(key)] = decodeURIComponent(value)

    return result
  }, {})
}

export const getQueryString = (query: Record<string, string | undefined | number | string[]>): string => {
  let result = ''

  keys(query).forEach((key) => {
    const value = query[key]

    if (isFinite(value) || !isEmpty(value)) {
      if (!isEmpty(result)) {
        result = `${result}&`
      }

      result = `${result}${key}=${value}`
    }
  })

  return result
}
